function ComparePlanejamento(original, modificado, key) {
    const resultado = {
      projeto: key,
      novosMeses: {},
      novos: {
        previstoFuncao: [],
        previstoIndireto: []
      },
      updates: {
        valorVenda: {},
        previstoFuncao: [],
        previstoIndireto: [],
        margemCusto: null,
        cliente: null
      },
      deletados: {
        previstoFuncao: [],
        previstoIndireto: [],
        meses: [],
        valorVenda: []
      }
    };

    const originalMeses = original.meses || {};
    const atualMeses = modificado.meses || {};

    // === NOVOS MESES ===
    for (const mes in atualMeses) {
      if (!originalMeses[mes]) {
        resultado.novosMeses[mes] = atualMeses[mes];
      }
    }

    // === MESES DELETADOS ===
    for (const mes in originalMeses) {
      if (!atualMeses[mes]) {
        resultado.deletados.meses.push(mes);
      }
    }

    // === COMPARA MESES EXISTENTES ===
    for (const mes in atualMeses) {
      if (!originalMeses[mes]) continue; // Já tratado em novosMeses

      const atual = atualMeses[mes];
      const originalMes = originalMeses[mes];

      // === VALOR VENDA ===
      if (atual.valorVenda !== originalMes.valorVenda) {
        resultado.updates.valorVenda[mes] = atual.valorVenda;
      }

      // === PREVISTO FUNÇÃO ===
      const originalFuncoes = originalMes.previstoFuncao || [];
      const atualFuncoes = atual.previstoFuncao || [];

      const originalFuncoesMap = new Map(originalFuncoes.map(f => [f.id, f]));

      for (const funcao of atualFuncoes) {
        if (!funcao.id) {
          resultado.novos.previstoFuncao.push(funcao);
        } else if (originalFuncoesMap.has(funcao.id)) {
          const originalFuncao = originalFuncoesMap.get(funcao.id);
          if (JSON.stringify(originalFuncao) !== JSON.stringify(funcao)) {
            resultado.updates.previstoFuncao.push(funcao);
          }
          originalFuncoesMap.delete(funcao.id); // Remove para rastrear o que foi deletado depois
        }
      }

      for (const [id] of originalFuncoesMap) {
        resultado.deletados.previstoFuncao.push({ id });
      }

      // === PREVISTO INDIRETO ===
      const originalIndiretos = originalMes.previstoIndireto || [];
      const atualIndiretos = atual.previstoIndireto || [];

      const originalIndiretosMap = new Map(originalIndiretos.map(f => [f.id, f]));

      for (const indireto of atualIndiretos) {
        if (!indireto.id) {
          resultado.novos.previstoIndireto.push(indireto);
        } else if (originalIndiretosMap.has(indireto.id)) {
          const originalIndireto = originalIndiretosMap.get(indireto.id);
          if (JSON.stringify(originalIndireto) !== JSON.stringify(indireto)) {
            resultado.updates.previstoIndireto.push(indireto);
          }
          originalIndiretosMap.delete(indireto.id);
        }
      }

      for (const [id] of originalIndiretosMap) {
        resultado.deletados.previstoIndireto.push({ id });
      }
    }

    // === TOTAL DO PROJETO ===
    if (JSON.stringify(original.previstoTotal) !== JSON.stringify(modificado.previstoTotal)) {
      resultado.updates.margemCusto = modificado.previstoTotal.margem_custo_projeto;
    }

    // === CLIENTE ===
    if (JSON.stringify(original.cliente) !== JSON.stringify(modificado.cliente)) {
      if (original.cliente.length === 0) {
        resultado.updates.cliente = {
          id: null,
          nome: modificado.cliente.nome,
          chave: modificado.cliente.chave
        };
      } else {
        resultado.updates.cliente = modificado.cliente;
      }
    }

    // === VALORES DE VENDA DELETADOS ===
    for (const mes in originalMeses) {
      if (atualMeses[mes] && originalMeses[mes].valorVenda && !atualMeses[mes].valorVenda) {
        resultado.deletados.valorVenda.push(mes);
      }
    }
    return resultado;
}

function Validations(planejamento) {
  const meses = Object.keys(planejamento.meses);
  let validate = true;
  let message = 'Projeto válido.';

  // Validação 1: Precisa ter pelo menos um mês no objeto
  if (planejamento.meses.length === 0) {
    validate = false;
    message = 'O projeto deve conter pelo menos um mês com dados.';
  }

  // Validação 2: Cada mês deve conter pelo menos um dos 3 dados
  for (const mes of meses) {
    const dados = planejamento.meses[mes];
    const temValorVenda = dados.valorVenda != null; 
    const temFuncoes = Array.isArray(dados.previstoFuncao) && dados.previstoFuncao.length > 0;
    const temCustosIndiretos = Array.isArray(dados.previstoIndireto) && dados.previstoIndireto.length > 0;
    const temCliente = planejamento.cliente.chave != "";

    if (!temValorVenda && !temFuncoes && !temCustosIndiretos && !temCliente) {
      validate = false;
      message = 'Um mês deve conter ao menos um dado (cliente, valor venda, função ou custo indireto).';
      break;
    }
  }

  return { validate, message };
}

const CompareData = {
  ComparePlanejamento,
  Validations
}

export default CompareData;
